import { useRef, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Clear from "@mui/icons-material/Clear";
import { ErrorMessage } from "@/shared/components";
import { useSignIn } from "@/admin/entities/auth";

interface SignInFormProps {
  onCompleted: (data: any, input?: { email?: string }) => void;
}

export function SignInForm({ onCompleted }: SignInFormProps) {
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const [signIn, { loading, error }] = useSignIn({
    onCompleted: (data) => {
      const trimmedValue = value.trim();
      let input: { email?: string } = {};

      input = { email: trimmedValue };

      onCompleted(data, input);
    },
  });

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const trimmedValue = value.trim();
    const variables = { input: { email: trimmedValue } };

    signIn({ variables });
  };

  // Валидация
  const isValid = () => {
    return value.trim().includes("@") && value.trim().includes(".");
  };

  // Определяем placeholder и label
  const getPlaceholder = () => {
    return "your@email.com";
  };

  const getLabel = () => {
    return "Email";
  };

  // Обработка изменения значения
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    setValue(inputValue);
  };

  return (
    <Box component="form" onSubmit={onSubmit}>
      <Stack spacing={3}>
        {error && <ErrorMessage error={error} />}

        <TextField
          autoFocus
          required
          fullWidth
          variant="outlined"
          label={getLabel()}
          placeholder={getPlaceholder()}
          disabled={loading}
          value={value}
          onChange={handleChange}
          type="email"
          slotProps={{
            input: {
              ref: inputRef,
              inputMode: "text",
              endAdornment: value && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear input"
                    onClick={() => setValue("")}
                    edge="end"
                    size="small"
                  >
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={!isValid() || loading}
        >
          Далее
        </Button>
      </Stack>
    </Box>
  );
}
